export const formatAxisLabel = (value: unknown): string => {
    const text = String(value ?? '');
    if (!text) {
        return '';
    }

    const date = parseAxisDate(text);
    if (!date) {
        return text.length > 12 ? `${text.slice(0, 12)}…` : text;
    }

    // Always include the day. Month + 2-digit year (e.g. "Jun 26") looks like a calendar day.
    return date.toLocaleDateString(undefined, { day: 'numeric', month: 'short', timeZone: 'UTC' });
};

export const formatAxisMonthLabel = (value: unknown, showYear: boolean): string => {
    const text = String(value ?? '');
    if (!text) {
        return '';
    }

    const date = parseAxisDate(text);
    if (!date) {
        return text.length > 12 ? `${text.slice(0, 12)}…` : text;
    }

    return date.toLocaleDateString(undefined, {
        month: 'long',
        year: showYear ? 'numeric' : undefined,
        timeZone: 'UTC'
    });
};

export const formatAxisWeekday = (value: unknown): string => {
    const text = String(value ?? '');
    const date = parseAxisDate(text);
    if (!date) {
        return '';
    }

    return date.toLocaleDateString(undefined, { weekday: 'short', timeZone: 'UTC' });
};

export const formatAxisDayNumber = (value: unknown): string => {
    const text = String(value ?? '');
    const date = parseAxisDate(text);
    if (!date) {
        return text;
    }

    return String(date.getUTCDate());
};

const parseAxisDate = (value: string): Date | null => {
    const trimmed = value.trim();
    if (!trimmed) {
        return null;
    }

    if (/^\d+$/.test(trimmed)) {
        const numeric = Number(trimmed);
        if (Number.isFinite(numeric)) {
            const milliseconds = numeric < 1e12 ? numeric * 1000 : numeric;
            const dateFromNumber = new Date(milliseconds);
            if (!Number.isNaN(dateFromNumber.getTime())) {
                return dateFromNumber;
            }
        }
    }

    const isoMatch = /^(\d{4})-(\d{2})-(\d{2})/.exec(trimmed);
    if (isoMatch) {
        return new Date(Date.UTC(Number(isoMatch[1]), Number(isoMatch[2]) - 1, Number(isoMatch[3])));
    }

    const dateFromString = new Date(trimmed);
    if (!Number.isNaN(dateFromString.getTime())) {
        return dateFromString;
    }

    return null;
};
